import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { COMPANY_OVERVIEW_NAMES } from 'components/BusinessToolForm/Sections/Overview/CompanyOverview/utils/form';
import { FUNDING_NEEDS_NAMES } from 'components/BusinessToolForm/Sections/Overview/FundingNeedsOverview/utils/form';
import { COMPANY_PROJECT_NAMES } from 'components/BusinessToolForm/Sections/Overview/ProjectOverview/utils/form';

import { ul } from '../helpers';

const OVERVIEW_COMPANY_INSTRUCTIONS = {
  [COMPANY_OVERVIEW_NAMES.LIFE_CYCLE_STAGES]: {
    name: 'Lebenszyklusphase',
    instruction:
      'Geben Sie die aktuelle Lebenszyklusphase Ihres Unternehmens prägnant an und heben Sie hervor, ob es sich in der Gründungs-, Wachstums-, Reife- oder Rückgangsphase befindet.',
  },
};

const OVERVIEW_PROJECT_INSTRUCTIONS = {
  [COMPANY_PROJECT_NAMES.STATUS]: {
    name: 'Projektstatus',
    instruction: `Wählen Sie die passende Projektphase aus:
      ${ul([
        'Ideenbewertung: Beurteilung der Machbarkeit und des Potenzials der Geschäftsidee.',
        'Forschung und Entwicklung: Erstellung von Prototypen, Tests sowie detaillierte Markt- oder Technikanalysen.',
        'Bewertung und Auswahl: Analyse verschiedener Strategien oder Modelle und Auswahl der am besten geeigneten Option.',
        'Finanzierung: Sicherstellung der notwendigen finanziellen Mittel zur Projektfinanzierung.',
        'Umsetzung: Durchführung des Businessplans und Markteinführung des Produkts oder der Dienstleistung.',
        'Betrieb und Management: Steuerung des laufenden Tagesgeschäfts und Sicherstellung eines effizienten Unternehmensbetriebs.',
      ])}`,
    exampleOne: 'Bewertung und Auswahl',
    exampleTwo: 'Implementierung',
  },
};

const FUNDING_NEEDS_INSTRUCTIONS = {
  [FUNDING_NEEDS_NAMES.FUNDING_DIRECTIONS]: {
    name: 'Verwendungszwecke der Finanzierung',
    instruction:
      'Geben Sie die Budgetzuweisungen für jeden Zweck an: Forschung und Entwicklung (F&E), Marketing und Vertrieb, Betriebskapital, Bau von Gebäuden und Anlagen, Kauf von Ausrüstung.',
    exampleOne: '',
    exampleTwo: '',
  },
};

export const OVERVIEW_INSTRUCTIONS = {
  [BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.COMPANY]: OVERVIEW_COMPANY_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.PROJECT]: OVERVIEW_PROJECT_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.FUNDING_NEEDS]: FUNDING_NEEDS_INSTRUCTIONS,
};
